/**
 * Select option value for the fragment's original media in the social export media selector.
 * Kept in social-export so upload UI can live in this module without depending on fragments.
 */
export const SOCIAL_EXPORT_FRAGMENT_SOURCE = 'fragment' as const;
